module.exports = __webpack_public_path__ + "static/media/select-test-on.a485270a.png";